<template>
  <div class="fastRecord">
    <!-- 左側：紀錄列表 -->
    <div class="left">
      <div class="filterBar">
        <Search :placeholder="'訂購商品'" :defaultValue="filterProduct" @input="filterProduct=$event" :width="'180px'"/>
        <Search :placeholder="'訂購人'" :defaultValue="filterOrderer" @input="filterOrderer=$event" :width="'250px'"/>
        <Select1 :width="'160px'" :defaultValue="filterSource" @input="filterSource=$event">
          <option :value="null">全部來源</option>
          <option v-for="src in sourceOptions" :key="src" :value="src">{{src}}</option>
        </Select1>
        <Select1 :width="'150px'" :defaultValue="filterStatus" @input="filterStatus=$event">
          <option :value="null">全部狀態</option>
          <option v-for="s in statusOptions" :key="s.value" :value="s.value">{{s.label}}</option>
        </Select1>
      </div>
      <div class="list">
        <div
          v-for="record in records"
          :key="record._id"
          class="listItem"
          :class="{active: selected && selected._id === record._id}"
          @click="selected = record"
        >
          <div class="row1">
            <span class="orderer">{{record.orderer || '(未填姓名)'}}</span>
            <span class="source" v-if="record.from_source">{{record.from_source}}</span>
            <span v-if="record.status" class="statusBadge" :class="statusCls(record.status)">{{record.status}}</span>
          </div>
          <div class="row2">
            <span class="itemCount">{{record.Orders.length}} 項商品</span>
            <span class="time">{{moment(record.updateTime).format('MM/DD HH:mm')}}</span>
          </div>
          <div v-if="record.remark" class="listRemark">{{record.remark}}</div>
        </div>
        <div v-if="records.length === 0" class="empty">無符合紀錄</div>
      </div>
    </div>

    <!-- 右側：購物車內容 -->
    <div class="right">
      <template v-if="selected">
        <div class="detailHeader">
          <div class="detailInfo">
            <span class="detailOrderer">{{selected.orderer || '(未填姓名)'}}</span>
            <button class="copyBtn" @click="copyOrderer" :class="{copied: copiedOrderer}">
              {{copiedOrderer ? '已複製' : '複製'}}
            </button>
            <span class="detailSource" v-if="selected.from_source">{{selected.from_source}}</span>
          </div>
          <div class="detailHeaderRight">
            <div class="detailTime">更新時間：{{moment(selected.updateTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
            <button v-if="selected.restId" class="createOrderBtn" @click="$router.push({ name: selected.store === '松柏軒' ? 'restaurantViewH' : selected.store === '松緣會館' ? 'restaurantView' : 'restaurantViewHTemp', query: { page: selected.store, start: toDate(selected.restId.visitDate), end: toDate(selected.restId.visitDate), id: selected.restId._id } })">{{toDate(selected.restId.visitDate)}}訂單</button>
            <button v-else class="createOrderBtn" @click="openCreatePopup">＋ 建立訂單</button>

          </div>
        </div>

        <!-- 狀態標記 -->
        <div class="statusBar">
          <span class="statusLabel">狀態</span>
          <button
            v-for="s in statusOptions"
            :key="s.value"
            class="statusBtn"
            :class="[s.cls, {active: selected.status === s.value}]"
            @click="setStatus(s.value)"
          >{{s.label}}</button>
          <button v-if="selected.status" class="statusBtn clear" @click="setStatus(null)">清除</button>
        </div>

        <!-- 備註編輯 -->
        <div class="remarkBlock">
          <div class="remarkLabel">備註</div>
          <textarea v-model="editRemark" class="remarkInput" rows="3" placeholder="輸入備註…"/>
          <button class="saveBtn" :disabled="editRemark === (selected.remark || '')" @click="saveRemark">儲存備註</button>
        </div>

        <div class="orderList">
          <div
            v-for="(order, idx) in selected.Orders"
            :key="order._id || idx"
            class="orderCard"
          >
            <div class="orderMain">
              <div class="orderName">{{order.name}}</div>
              <div class="orderMeta">
                <span class="orderCount">x {{order.count}}</span>
                <span class="orderPrice" v-if="order.price != null">${{order.price}}</span>
              </div>
            </div>
            <!-- 套餐子項目 -->
            <div class="orderItems" v-if="order.items && order.items.length">
              <div v-for="(itm, i) in order.items" :key="i" class="orderItem">
                <span>└ {{itm.item ? itm.item.name : itm.name}}</span>
                <span v-if="itm.add && itm.add.length" class="addons">
                  ＋{{itm.add.map(a => a.item ? a.item.name : '').filter(Boolean).join('、')}}
                </span>
              </div>
            </div>
            <div class="orderRemark" v-if="order.remark">備註：{{order.remark}}</div>
          </div>
          <div v-if="selected.Orders.length === 0" class="empty">購物車為空</div>
        </div>
      </template>
      <div v-else class="placeholder">請選擇左側紀錄查看購物車內容</div>
    </div>

    <!-- 建立訂單 Popup -->
    <div class="popup" v-if="showCreatePopup" @click.self="showCreatePopup=false">
      <div class="popupBox">
        <div class="popupTitle">建立訂單</div>
        <div class="popupRow">
          <span class="popupRowLabel">日期</span>
          <DateInput :defaultValue="createForm.visitDate" @input="createForm.visitDate=$event"/>
        </div>
        <div class="popupRow">
          <span class="popupRowLabel">時間</span>
          <TimeInput :defaultValue="createForm.visitTime" @input="createForm.visitTime=$event"/>
        </div>
        <div class="popupRow">
          <span class="popupRowLabel">類型</span>
          <div class="typeGroup">
            <button
              v-for="t in ['宅配','自取']"
              :key="t"
              class="typeBtn"
              :class="{active: createForm.type===t}"
              @click="createForm.type=t"
            >{{t}}</button>
          </div>
        </div>
        <div class="popupActions">
          <button class="cancelBtn" @click="showCreatePopup=false">取消</button>
          <button class="confirmBtn" :disabled="!createForm.visitDate||!createForm.type" @click="submitCreateOrder">確認建立</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getapi, putapi, postapi } from '../../store/fetch'
import Search from '../../components/input/search.vue'
import DateInput from '../../components/input/date.vue'
import TimeInput from '../../components/input/time.vue'
export default {
  name: 'FastRecord',
  components: { Search, DateInput, TimeInput },
  props: ['project'],
  data () {
    return {
      records: [],
      sourcesCache: [],
      selected: null,
      editRemark: '',
      filterProduct: null,
      filterOrderer: null,
      filterSource: null,
      filterStatus: null,
      statusOptions: [
        { value: '新訊息', label: '新訊息', cls: 'newMsg' },
        { value: '已聯繫', label: '已聯繫', cls: 'contacted' },
        { value: '成單', label: '成單', cls: 'won' },
        { value: '無回應', label: '無回應', cls: 'noReply' },
        { value: '取消', label: '取消', cls: 'cancelled' }
      ],
      showCreatePopup: false,
      createForm: { visitDate: null, visitTime: null, type: '自取' },
      copiedOrderer: false
    }
  },
  computed: {
    sourceOptions () {
      return this.sourcesCache
    }
  },
  watch: {
    project: {
      immediate: true,
      async handler (val) {
        if (val && val._id) {
          await this.fetchRecords()
          this.sourcesCache = Array.from(new Set(this.records.map(r => r.from_source).filter(Boolean)))
        }
      }
    },
    selected (val) {
      this.editRemark = (val && val.remark) || ''
    },
    filterOrderer () { this.debounceSearch() },
    filterProduct () { this.debounceSearch() },
    filterSource () { this.fetchRecords() },
    filterStatus () { this.fetchRecords() }
  },
  methods: {
    debounceSearch () {
      clearTimeout(this._debounceTimer)
      this._debounceTimer = setTimeout(() => this.fetchRecords(), 300)
    },
    async fetchRecords () {
      const params = {}
      if (this.filterOrderer) params.orderer = this.filterOrderer
      if (this.filterSource) params.from_source = this.filterSource
      if (this.filterProduct) params.product = this.filterProduct
      if (this.filterStatus) params.status = this.filterStatus
      const qs = new URLSearchParams(params).toString()
      const data = await getapi(`fast_restaurant/${this.project.projectId}${qs ? '?' + qs : ''}`)
      this.records = data || []
    },
    async setStatus (status) {
      const updated = await postapi(`fast_restaurant/one/${this.selected._id}`, { status })
      this.syncRecord(updated)
    },
    async saveRemark () {
      const updated = await postapi(`fast_restaurant/one/${this.selected._id}`, { remark: this.editRemark })
      this.syncRecord(updated)
    },
    syncRecord (updated) {
      if (!updated) return
      const idx = this.records.findIndex(r => r._id === updated._id)
      if (idx !== -1) this.$set(this.records, idx, updated)
      this.selected = updated
    },
    statusCls (status) {
      const map = { 新訊息: 'newMsg', 已聯繫: 'contacted', 成單: 'won', 無回應: 'noReply', 取消: 'cancelled' }
      return map[status] || ''
    },
    openCreatePopup () {
      this.createForm = {
        visitDate: this.moment().format('YYYY-MM-DD'),
        visitTime: this.moment().format('HH:mm'),
        type: '自取'
      }
      this.showCreatePopup = true
    },
    async copyOrderer () {
      const text = this.selected.orderer || ''
      if (!text) return
      await navigator.clipboard.writeText(text)
      this.copiedOrderer = true
      setTimeout(() => { this.copiedOrderer = false }, 1500)
    },
    async submitCreateOrder () {
      const depopulateItem = (id) => (id && typeof id === 'object') ? (id._id || id) : id
      const orders = this.selected.Orders.map(o => ({
        ...o,
        _id: undefined,
        items: (o.items || []).map(itm => ({
          ...itm,
          _id: undefined,
          item: depopulateItem(itm.item),
          add: (itm.add || []).map(a => ({ ...a, item: depopulateItem(a.item) }))
        }))
      }))
      const body = {
        visitDate: this.createForm.visitDate,
        visitTime: this.createForm.visitTime,
        type: this.createForm.type,
        status: this.storeType === 'restaurant' ? '預約中' : '新訂單',
        store: this.selected.store,
        orderer: this.selected.orderer,
        project: this.selected.project,
        projectId: this.selected.projectId,
        from_source: this.selected.from_source,
        remark: this.selected.remark,
        reserveNum: 1,
        reserveNumChild: 0,
        agency: {
          taxID: null,
          name: null
        },
        Orders: orders
      }
      const result = await putapi('restaurant', body)
      if (result && result._id) {
        this.showCreatePopup = false
        const updated = await postapi(`fast_restaurant/one/${this.selected._id}`, { status: '成單', restId: result._id })
        this.syncRecord(updated)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fastRecord {
  display: grid;
  grid-template-columns: 860px 1fr;
  height: calc(100vh - 89px);
  overflow: hidden;
}

/* ── 左側 ── */
.left {
  display: grid;
  grid-template-rows: 71px 1fr;
  border-right: 1px solid var(--color-fn9);
  overflow: hidden;
}

.filterBar {
  height: 71px;
  padding-inline: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid var(--color-fn9);
  flex-wrap: wrap;
}

.list {
  overflow-y: auto;
}

.listItem {
  padding: 14px 20px;
  border-bottom: 1px solid var(--color-fn9);
  cursor: pointer;
  transition: background-color 0.15s;
  &:hover {
    background-color: #f5f5f5;
  }
  &.active {
    background-color: #fffae7;
    border-left: 3px solid var(--color-pri);
  }
}

.row1 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.orderer {
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.source {
  font-size: 14px;
  color: #FFFFFF;
  background-color: var(--color-pri);
  border-radius: 10px;
  padding: 2px 10px;
}

.row2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.itemCount {
  font-size: 16px;
  color: #999;
}

.time {
  font-size: 14px;
  color: #aaa;
}

.listRemark {
  margin-top: 5px;
  font-size: 16px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}

/* ── 右側 ── */
.right {
  overflow-y: auto;
  padding: 30px 36px;
  background-color: #fafafa;
}

.placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #bbb;
}

.detailHeader {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-fn9);
}

.detailInfo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.detailOrderer {
  font-size: 22px;
  font-weight: 600;
  color: #222;
}

.copyBtn {
  height: 28px;
  padding-inline: 12px;
  border-radius: 14px;
  border: 1px solid #ccc;
  background: #fff;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.15s;
  &:hover { border-color: var(--color-pri); color: var(--color-pri); }
  &.copied { border-color: #4caf50; color: #4caf50; }
}

.detailSource {
  font-size: 15px;
  color: #FFFFFF;
  background-color: var(--color-pri);
  border-radius: 12px;
  padding: 3px 14px;
}

.detailTime {
  font-size: 15px;
  color: #888;
}

.orderList {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.orderCard {
  background: #FFFFFF;
  border-radius: 10px;
  padding: 18px 22px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
}

.orderMain {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.orderName {
  font-size: 22px;
  font-weight: 500;
  color: #222;
}

.orderMeta {
  display: flex;
  align-items: center;
  gap: 16px;
}

.orderCount {
  font-size: 16px;
  color: #666;
}

.orderPrice {
  font-size: 22px;
  font-weight: 500;
  color: var(--color-pri);
}

.orderItems {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 12px;
}

.orderItem {
  font-size: 18px;
  color: #777;
  display: flex;
  align-items: center;
  gap: 8px;
  .addons {
    color: #aaa;
    font-size: 14px;
  }
}

.orderRemark {
  margin-top: 10px;
  font-size: 14px;
  color: #aaa;
}

.detailRemark {
  margin-top: 20px;
  padding: 12px 16px;
  background: #fff3cd;
  border-radius: 8px;
  font-size: 15px;
  color: #666;
}

.empty {
  padding: 40px;
  text-align: center;
  color: #ccc;
  font-size: 16px;
}

/* ── 狀態 badge（左側列表） ── */
.statusBadge {
  font-size: 12px;
  border-radius: 8px;
  padding: 2px 8px;
  &.newMsg    { background: #f3e5f5; color: #6a1b9a; }
  &.contacted { background: #e3f2fd; color: #1565c0; }
  &.won       { background: #e8f5e9; color: #2e7d32; }
  &.noReply   { background: #fff3e0; color: #e65100; }
  &.cancelled { background: #fce4ec; color: #b71c1c; }
}

/* ── 狀態列 ── */
.statusBar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.statusLabel {
  font-size: 15px;
  color: #888;
  margin-right: 4px;
}
.statusBtn {
  height: 40px;
  padding-inline: 16px;
  border-radius: 20px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.15s;
  &.newMsg    { color: #6a1b9a; border-color: #6a1b9a; &.active, &:hover { background: #6a1b9a; color: #fff; } }
  &.contacted { color: #1565c0; border-color: #1565c0; &.active, &:hover { background: #1565c0; color: #fff; } }
  &.won       { color: #2e7d32; border-color: #2e7d32; &.active, &:hover { background: #2e7d32; color: #fff; } }
  &.noReply   { color: #e65100; border-color: #e65100; &.active, &:hover { background: #e65100; color: #fff; } }
  &.cancelled { color: #b71c1c; border-color: #b71c1c; &.active, &:hover { background: #b71c1c; color: #fff; } }
  &.clear     { color: #aaa; border-color: #ccc; font-size: 18px; &:hover { background: #f5f5f5; } }
}

/* ── 備註編輯 ── */
.remarkBlock {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.remarkLabel {
  font-size: 18px;
  color: #888;
}
.remarkInput {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 18px;
  resize: vertical;
  font-family: inherit;
  line-height: 1.6;
  &:focus { outline: none; border-color: var(--color-pri); }
}
.saveBtn {
  align-self: flex-end;
  height: 40px;
  padding-inline: 24px;
  border-radius: 20px;
  border: none;
  background: var(--color-pri);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  &:disabled { background: #ccc; cursor: default; }
}

/* ── detailHeader 右側 ── */
.detailHeaderRight {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.createOrderBtn {
  height: 40px;
  padding-inline: 20px;
  border-radius: 20px;
  border: none;
  background: var(--color-checked, #4caf50);
  color: #fff;
  font-size: 18px;
  letter-spacing: 2px;
  cursor: pointer;
  white-space: nowrap;
  &:hover { opacity: 0.88; }
}

/* ── Popup ── */
.popup {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  backdrop-filter: blur(3px);
  z-index: 300;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popupBox {
  background: #fff;
  border-radius: 14px;
  padding: 36px 40px 32px;
  width: 440px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.popupTitle {
  font-size: 20px;
  font-weight: 600;
  color: #222;
}
.popupRow {
  display: flex;
  align-items: center;
  gap: 16px;
}
.popupRowLabel {
  font-size: 16px;
  color: #666;
  width: 40px;
  flex-shrink: 0;
}
.typeGroup {
  display: flex;
  gap: 10px;
}
.typeBtn {
  height: 38px;
  padding-inline: 22px;
  border-radius: 19px;
  border: 1px solid #ccc;
  background: #fff;
  font-size: 16px;
  cursor: pointer;
  &.active {
    background: var(--color-pri);
    color: #fff;
    border-color: var(--color-pri);
  }
}
.popupActions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 14px;
  letter-spacing: .1em;
}
.cancelBtn {
  height: 40px;
  padding-inline: 24px;
  border-radius: 20px;
  // border: 1px solid #ccc;
  background: #CACACA;
  color: #FFFFFF;
  font-size: 16px;
  letter-spacing: .1em;
  cursor: pointer;
  &:hover { background: #f5f5f5; }
}
.confirmBtn {
  height: 40px;
  padding-inline: 28px;
  border-radius: 20px;
  border: none;
  background: var(--highlight);
  color: #fff;
  font-size: 16px;
  letter-spacing: .1em;
  cursor: pointer;
  &:disabled { background: #ccc; cursor: default; }
  &:not(:disabled):hover { opacity: 0.88; }
}
</style>
